import {
	applyActiveAlarmsFilter,
	applyHistoricalAlarmsFilter,
	applySwitchEventsFilter,
	focusActiveAlarm,
	focusHistoricalAlarm,
	focusSwitchEvent,
	openActiveAlarmsSection,
	openAlarmsSection,
	openHistoricalAlarmsSection,
	openSwitchEventsSection,
} from './adapter';
import {
	openAlarmsAcknowledgeModal,
	openAlarmsConfigureModal,
	openHistoricalAlarmsDeleteModal,
} from './modal';
import {
	resolveActiveAlarms,
	resolveHistoricalAlarms,
	resolveSwitchEvents,
} from './resolver';
import {serializeAlarmsContext} from './context';
import {readAlarmCounts} from './statistics';

const alarmsPlugin = {
	id: 'alarms',
	version: 1,
	commandVersion: 1,
	resource: 'alarms',
	operations: [
		'options',
		'view',
		'search',
		'download_inventory',
		'acknowledge',
		'configure',
		'refresh',
		'create',
		'edit',
		'delete',
		'unacknowledge',
	],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['maintenance.dashboard'],
	},
	sections: {
		'maintenance.alarms': openAlarmsSection,
		'maintenance.active_alarms': openActiveAlarmsSection,
	},
	resolvers: {
		alarm: resolveActiveAlarms,
	},
	filters: {
		alarm: applyActiveAlarmsFilter,
	},
	focusHandlers: {
		alarm: focusActiveAlarm,
	},
	statistics: {
		alarm_count: readAlarmCounts,
	},
	modals: {
		'alarms.acknowledge': openAlarmsAcknowledgeModal,
		'alarms.configure': openAlarmsConfigureModal,
	},
	contextSerializers: {
		alarms: serializeAlarmsContext,
	},
};

const historicalAlarmsPlugin = {
	id: 'historical_alarms',
	version: 1,
	commandVersion: 1,
	resource: 'historical_alarms',
	operations: [
		'options',
		'view',
		'search',
		'download_inventory',
		'delete',
		'bulk_delete',
		'refresh',
		'acknowledge',
		'create',
	],
	dependencies: {
		plugins: ['canvas.navigation', 'alarms'],
		destinations: ['maintenance.dashboard'],
	},
	sections: {
		'maintenance.historical_alarms': openHistoricalAlarmsSection,
	},
	resolvers: {
		historical_alarm: resolveHistoricalAlarms,
	},
	filters: {
		historical_alarm: applyHistoricalAlarmsFilter,
	},
	focusHandlers: {
		historical_alarm: focusHistoricalAlarm,
	},
	modals: {
		'historical_alarms.delete': openHistoricalAlarmsDeleteModal,
	},
	contextSerializers: {
		historical_alarms: serializeAlarmsContext,
	},
};

const switchEventsPlugin = {
	id: 'switch_events',
	version: 1,
	commandVersion: 1,
	resource: 'switch_events',
	operations: [
		'options',
		'view',
		'search',
		'refresh',
		'download_inventory',
		'delete',
		'acknowledge',
	],
	dependencies: {
		plugins: ['canvas.navigation', 'alarms'],
		destinations: ['maintenance.dashboard'],
	},
	sections: {
		'maintenance.switch_events': openSwitchEventsSection,
	},
	resolvers: {
		switch_event: resolveSwitchEvents,
	},
	filters: {
		switch_event: applySwitchEventsFilter,
	},
	focusHandlers: {
		switch_event: focusSwitchEvent,
	},
};

export {historicalAlarmsPlugin, switchEventsPlugin};
export default alarmsPlugin;
